import { render, staticRenderFns } from "./commodityFacility.vue?vue&type=template&id=00a1b8ea&scoped=true"
import script from "./commodityFacility.vue?vue&type=script&lang=js"
export * from "./commodityFacility.vue?vue&type=script&lang=js"
import style0 from "./commodityFacility.vue?vue&type=style&index=0&id=00a1b8ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a1b8ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a1b8ea')) {
      api.createRecord('00a1b8ea', component.options)
    } else {
      api.reload('00a1b8ea', component.options)
    }
    module.hot.accept("./commodityFacility.vue?vue&type=template&id=00a1b8ea&scoped=true", function () {
      api.rerender('00a1b8ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/commodityFacility/commodityFacility.vue"
export default component.exports